export const GET_ALL_PENDING_TABLES = "GET_ALL_PENDING_TABLES";
export const DELETE_PENDING_TABLE = "DELETE_PENDING_TABLE";
export const ADD_PENDING_TABLE = "ADD_PENDING_TABLE"